import { Divider } from 'antd';
import Container from 'common/components/container.component';
import Pulsate from 'common/components/pulsate.component';
import React from 'react';
import styles from './style.module.scss';

const MyPurchasesPageSkeleton: React.FC = () => {
  return (
    <Container>
      <div className={styles['desktop-my-purchases-page-skeleton-title']}>
        <Pulsate width='40%' height='60px' />
        <Pulsate width='25%' height='40px' />
      </div>
      <Divider />
      <div className={styles['desktop-my-purchases-page-skeleton-container']}>
        <div className={styles['list-item']}>
          <Pulsate width='70%' height='150px' />
          <Pulsate width='10%' height='50px' />
        </div>
        <Divider />
        <div className={styles['list-item']}>
          <Pulsate width='70%' height='150px' />
          <Pulsate width='10%' height='50px' />
        </div>
        <Divider />
        <div className={styles['list-item']}>
          <Pulsate width='70%' height='150px' />
          <Pulsate width='10%' height='50px' />
        </div>
        <Divider />
        <div className={styles['list-item']}>
          <Pulsate width='70%' height='150px' />
          <Pulsate width='10%' height='50px' />
        </div>
        <Divider />
      </div>
    </Container>
  );
};

export default MyPurchasesPageSkeleton;
